module.exports = __webpack_public_path__ + "img/wx.anttalk.vip.9dbec86b.png";